import { render } from "./FolderCards.vue?vue&type=template&id=be93c796&scoped=true"
import script from "./FolderCards.vue?vue&type=script&lang=js"
export * from "./FolderCards.vue?vue&type=script&lang=js"

import "./FolderCards.vue?vue&type=style&index=0&id=be93c796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be93c796"]])

export default __exports__